import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: "dark" | "light";
  align?: "center" | "left";
  className?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = "dark",
  align = "center",
  className = ""
}: SectionHeadingProps) {
  const alignment = align === "center" ? "mx-auto text-center" : "text-left";
  const isDark = tone === "dark";
  return <div className={`max-w-3xl ${alignment} ${className}`} data-id="element-258" data-mp="bl588g4c2w2q">
      {eyebrow && <p className={`font-display text-xs font-extrabold uppercase tracking-[0.18em] md:text-[13px] ${isDark ? "text-gold-deep" : "text-gold"}`} data-id="element-259" data-mp="gi56w5yuswjt">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-display text-[1.85rem] font-extrabold leading-[1.12] tracking-tight md:text-[2.6rem] md:leading-[1.08] ${isDark ? "text-ink" : "text-white"}`} data-id="element-260" data-mp="6svesq40fdvp">
        {title}
      </h2>
      {subtitle && <div className={`mt-4 space-y-2 text-base leading-relaxed md:text-lg ${isDark ? "text-ink-soft" : "text-white/85"}`} data-id="element-261" data-mp="zapvvcbfmhic">
          {subtitle}
        </div>}
    </div>;
}